<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body clinic-doctor-wrapper">

        <h4 class="step-header">
          <div class='title'>{{$t('message.doctors.title')}}</div>
          <button v-if="!showAddPanel" @click.prevent="enterCreateMode" class="add-service btn btn-success">+ {{$t('action_message.add')}}</button>
          <button v-if="showAddPanel" @click.prevent="showAddPanel = !showAddPanel" class="add-service btn btn-info">{{$t('action_message.list')}}</button>
        </h4>

        <div class='doctor-wrapper' v-if="!showAddPanel">
          <div class="row" v-if="!isStepPrcess">
            <div class="col-4">
              <bs-input v-model='q' :placeholder="$t('message.doctors.search_doctor')" v-if="!isStepPrcess"></bs-input>
            </div>
            
            <div class="col-4">
              <multiselect id="specialty_filter"
                    v-model="selected_specialty_filters" 
                    :placeholder="$t('message.doctors.filter_specialty')" 
                    :options="specialty_filters" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>
            <div class="col-4">
              <multiselect id="subspecialty_filter"
                    v-model="selected_subspecialty_filters" 
                    :placeholder="$t('message.doctors.filter_subspecialty')" 
                    :options="subspecialty_filters" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
              </div>
          </div>

          <div class='pagination' v-if="!isStepPrcess">
            <div><strong>{{$t('message.pagination.show')}}</strong> {{ paginator.from }} - {{ paginator.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ paginator.total }} <strong>{{$t('message.doctors.doctor_unit')}}</strong></div>
            <a class='btn' @click="paginator.prev_page_url && refreshDoctorList(paginator.prev_page_url)" :class="{ enable: paginator.prev_page_url }">{{$t('message.pagination.prev')}}</a>
            <a class='btn' @click="paginator.next_page_url && refreshDoctorList(paginator.next_page_url)" :class="{ enable: paginator.next_page_url }">{{$t('message.pagination.next')}}</a>
          </div>

          <div v-if="doctors.length > 0" >
            <div class="doctor-container" v-for="(d, index) in doctor_list" :key="d">
              <div class='doctor-content' @click="editDoctor(d)">
                <h6>{{ ($i18n.locale === 'th') ? d.name_th : d.name_en }}</h6>
                <div>{{ d.specialities[0] && (($i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en) }} : {{ display_sub_specialities(d) }}</div>
              </div>
              <div class='doctor-actions'>
                <a :href="$APP_CONFIG.api.domain + '/doctor/d-' + d.id" target="_blank">
                  <i class="fa fa-eye"></i>
                  <div v-if="!$ismobile()">
                    <small>{{$t('action_message.view')}}</small>
                  </div>
                </a>
              </div>
              <div class='doctor-actions'>
                <i class="fa fa-qrcode" @click="showQRCode(d)"></i>
                <div v-if="!$ismobile()">
                  <small>{{$t('message.doctors.qr_code')}}</small>
                </div>
              </div>
              <div class='doctor-actions'>
                <i class="fa fa-pencil-square-o" @click="editDoctor(d)"></i>
                <div v-if="!$ismobile()">
                  <small>{{$t('action_message.edit')}}</small>
                </div>
              </div>
            </div>
          </div>
          <h6 class="alert alert-warning" v-else>
            {{$t('message.doctors.no_doctor')}}
          </h6>
        </div>

        <div v-if="showAddPanel" class="doctor-form">
          <h6>{{$t('message.doctors.name_th')}}</h6>
          <div class="flex">
            <div>
              <bs-input class='prefix-name remove-margin-bottom' :label="$t('message.doctors.prefix')" v-model="doctor.th.prefix" :placeholder="$t('message.doctors.prefix')"></bs-input>
              <error-box :message="frmError['th.prefix']"/>
              <div class="add-margin-bottom"/>
            </div>
            <div class="name">
              <bs-input class='remove-margin-bottom' :label="$t('message.doctors.firstname')" v-model="doctor.th.firstname" :placeholder="$t('message.doctors.firstname')"></bs-input>
              <error-box :message="frmError['th.firstname']"/>
              <div class="add-margin-bottom"/>
            </div>
          </div>
          <bs-input class='remove-margin-bottom' :label="$t('message.doctors.lastname')" v-model="doctor.th.lastname" :placeholder="$t('message.doctors.lastname')"></bs-input>
          <error-box :message="frmError['th.lastname']"/>
          <div class="add-margin-bottom"/>

          <div class="form-divider"></div>
          <h6>{{$t('message.doctors.name_en')}}</h6>
          <div class="flex">
            <div>
              <bs-input class='prefix-name remove-margin-bottom' :label="$t('message.doctors.prefix')" v-model="doctor.en.prefix" :placeholder="$t('message.doctors.prefix')"></bs-input>
              <error-box :message="frmError['en.prefix']"/>
              <div class="add-margin-bottom"/>
            </div>
            <div class='name'>
              <bs-input class='remove-margin-bottom' :label="$t('message.doctors.firstname')" v-model="doctor.en.firstname" :placeholder="$t('message.doctors.firstname')"></bs-input>
              <error-box :message="frmError['en.firstname']"/>
              <div class="add-margin-bottom"/>
            </div>
          </div>
          <bs-input class="remove-margin-bottom" :label="$t('message.doctors.lastname')" v-model="doctor.en.lastname" :placeholder="$t('message.doctors.lastname')"></bs-input>
          <error-box :message="frmError['en.lastname']"/>
          <div class="add-margin-bottom"/>

          <div class="form-divider"></div>

          <h6>{{$t('message.doctors.gender')}}</h6>
          <div class="gender-select">
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="m" v-model="doctor.gender"> <i class="fa fa-male fa-lg" aria-hidden="true"></i> {{$t('message.doctors.male')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="f" v-model="doctor.gender"> <i class="fa fa-female fa-lg" aria-hidden="true"></i> {{$t('message.doctors.female')}}
              </label>
            </div>
          </div>
            
          <div class="form-divider"></div>

          <h6>{{$t('message.doctors.specialty')}}</h6>

          <div class="form-group">
            <label for="name">{{$t('message.doctors.specialty')}}</label>
            <multiselect id="speciality" 
                    class="multi-select-form"
                    v-model="selected_specialities" 
                    :placeholder="$t('message.doctors.specialty_placeholder')" 
                    :options="select_specialties_options"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            <error-box :message="frmError.specialities"/>
          </div>

          <div class="form-group">
            <label for="name">{{$t('message.doctors.subspecialty')}}</label>
            <multiselect id="subspeciality" 
                    class="multi-select-form"
                    v-model="selected_sub_specialities" 
                    :placeholder="$t('message.doctors.subspecialty_placeholder')" 
                    :options="sub_specialities" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          </div>

          <div class="form-divider"></div>

          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-lg btn-close" @click="cancelAddingDoctor">{{$t('action_message.cancel')}}</button>
              <button class="btn btn-add btn-lg btn-success" @click="addDoctor">{{ editMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
              <button v-if="editMode" class="btn btn-add btn-lg btn-danger remove-doctor-action" @click="removeDoctor">{{$t('action_message.remove')}}</button>
            </div>
          </div>
        </div>

        <div class="row" v-if="!showAddPanel">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <slot name='loader'></slot>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal ref="qrCodeModal" overlay-theme="dark">
      <div class="row">
        <div class='col-md-12'>
          <vue-qrcode id="doctorQrCanvas" :value="doctorQrUrl" :options="{ size: 200 }"></vue-qrcode>
        </div>
        <div class='col-md-12'>
          <button class="btn btn-success" @click="downloadDoctorQr">{{$t('action_message.download_qr_code')}}</button>
          <a ref="doctorQrLink"></a>
          </br>
          </br>
        </div>
        <div class='col-md-12'>
          <a :href="doctorQrUrl" target="_blank">
            {{doctorQrUrl}}
          </a>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import alertbar from '@/components/AlertBar'
import { input as BsInput } from 'vue-strap'
import Multiselect from 'vue-multiselect'
import router from '@/router'
import errorBox from '@/components/ErrorMessageBox'
import { SweetModal } from 'sweet-modal-vue'
import VueQrcode from '@xkeshi/vue-qrcode'

export default {
  components: {
    BsInput,
    Multiselect,
    alertbar,
    errorBox,
    SweetModal,
    VueQrcode
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data () {
    let defaultDoctor = {
      th: {
        prefix: ''
      },
      en: {},
      gender: 'm',
      isStep: true
    }

    return {
      _searchQ: null, // timeout inst
      q: '',
      showAddPanel: false,
      editMode: false,
      defaultDoctor,
      doctor: Object.assign({}, defaultDoctor),
      doctors: [],
      selected_specialities: null,
      selected_sub_specialities: [],
      specialities: [],
      sub_specialities: [],
      paginator: {},
      frmError: this.getFormError(),
      selected_doctor_filter: null,
      selected_specialty_filter: null,
      selected_subspecialty_filter: null,
      selected_specialty_filters: [],
      selected_subspecialty_filters: [],
      selected_doctor_filters: [],
      doctor_filters: [],
      specialty_filters: [],
      subspecialty_filters: [],
      doctorSearching: false,
      doctorQrUrl: ''
    }
  },
  computed: {
    select_specialties_options () {
      return this.specialities.map(function (s) {
        return { label: s.name, value: s.id }
      })
    },
    doctor_list () {
      return this.doctors.sort((a, b) => a.created_at < b.created_at)
    }
  },
  methods: {
    enterCreateMode () {
      this.showAddPanel = true
      this.editMode = false
      this.doctor = Object.assign(this.doctor, this.defaultDoctor) // reset doctor
    },
    editDoctor (d) {
      router.push({
        path: `/doctor/step1/${d.id}`,
        query: {
          action: 'edit',
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      })
    },
    showQRCode (d) {
      this.doctorQrUrl = `${this.$APP_CONFIG.api.domain}/doctor/d-${d.id}`
      this.$refs.qrCodeModal.open()
    },
    downloadDoctorQr () {
      this.$refs.doctorQrLink.href = document.getElementById('doctorQrCanvas').toDataURL()
      this.$refs.doctorQrLink.download = `qr-code`
      this.$refs.doctorQrLink.click()
    },
    saveAndContinue () {
      this.$emit('finishStep')
    },
    cancelChange () {
      this.$emit('cancelChange')
    },
    refreshDoctorList (url) {
      var newParams = {clinic_id: this.clinic.id}
      // if (this.selected_doctor_filter) {
      //   newParams.doctor_name = encodeURI(this.selected_doctor_filter.label)
      // }
      if (this.q) {
        newParams.doctor_name = this.q
      }
      if (this.selected_specialty_filter) {
        newParams.speciality_id = this.selected_specialty_filter.value
      }
      if (this.selected_subspecialty_filter) {
        newParams.subspeciality_id = this.selected_subspecialty_filter.value
      }

      this.$http.get(url || this.$APP_CONFIG.api.admin.doctors(),
        { params: newParams }).then(res => {
          this.doctors = res.body.data || []

          Object.assign(this.paginator, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.per_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          })
        }, errorResponse => {
          console.error(errorResponse)
        })
    },
    display_sub_specialities (doctor) {
      let self = this
      return doctor.subspecialities.map(s => { return (self.$i18n.locale === 'th') ? s.name_th : s.name_en }).join(', ')
    },
    addDoctor () {
      if (this.editMode) {
        this._updataDoctor()
      } else {
        if (!this.checkInvalidForm()) {
          return
        }

        this.clearFormError()

        this.$http.post(this.$APP_CONFIG.api.admin.doctors(),
          // data
          {
            th: this.doctor.th,
            en: this.doctor.en,
            specialities: [+this.selected_specialities.value],
            subspecialities: this.selected_sub_specialities.map(s => +s.value),
            gender: this.doctor.gender,
            clinics: [this.clinic.id]
          },
          // options
          {
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            if (res.body.status === 'success') {
              if (res.body.data.id) {
                this.editDoctor(res.body.data)
              }
              // save success
              this.doctor = Object.assign({}, this.defaultDoctor)
              // go to list panel
              this.showAddPanel = false
              // append service
              this.refreshDoctorList()
            }
          },
          error => {
            if (error.body.error) {
              this.showFormFromError(error.body.error)
            }
          })
      }
    },
    _updataDoctor () {
      if (!this.checkInvalidForm()) {
        return
      }

      this.clearFormError()

      this.$http.put(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id),
        // data
        {
          th: this.doctor.th,
          en: this.doctor.en,
          specialities: [+this.selected_specialities.value],
          subspecialities: this.selected_sub_specialities.map(s => +s.value)
        },
        // options
        {
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.status === 'success') {
            // save success
            this.doctor = this.defaultDoctor
            // go to list panel
            this.showAddPanel = false
            // append service
            this.refreshDoctorList()
          }
        },
        error => {
          if (error.body.error) {
            this.showFormFromError(error.body.error)
          }
        })
    },
    async removeDoctor () {
      if (await this.$confirm('Are you sure ?')) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id),
          {
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            // save success
            this.doctor = this.defaultDoctor
            // go to list panel
            this.showAddPanel = false
            // append service
            // this.refreshDoctorList()
          })
      }
    },
    cancelAddingDoctor () {
      this.showAddPanel = false
      this.editMode = false
      this.doctor = this.defaultDoctor
    },
    checkInvalidForm () {
      let defaultFrmError = this.getFormDefaultError()
      if (!this.selected_specialities) {
        this.frmError.specialities = defaultFrmError.specialities
        return false
      }
      return true
    },
    clearFormError () {
      this.frmError = this.getFormError()
    },
    getFormError () {
      return {
        'th.prefix': null,
        'th.firstname': null,
        'th.lastname': null,
        'en.prefix': null,
        'en.firstname': null,
        'en.lastname': null,
        specialities: null
      }
    },
    getFormDefaultError () {
      return {
        'th.prefix': this.$t('message.doctors.prefix_required'),
        'th.firstname': this.$t('message.doctors.firstname_required'),
        'th.lastname': this.$t('message.doctors.lastname_required'),
        'en.prefix': this.$t('message.doctors.prefix_required'),
        'en.firstname': this.$t('message.doctors.firstname_required'),
        'en.lastname': this.$t('message.doctors.lastname_required'),
        specialities: this.$t('message.doctors.specialty_required')
      }
    },
    showFormFromError (error) {
      if (error) {
        this.frmError['th.prefix'] = this.getMessageFromError(error['th.prefix'])
        this.frmError['th.firstname'] = this.getMessageFromError(error['th.firstname'])
        this.frmError['th.lastname'] = this.getMessageFromError(error['th.lastname'])
        this.frmError['en.prefix'] = this.getMessageFromError(error['en.prefix'])
        this.frmError['en.firstname'] = this.getMessageFromError(error['en.firstname'])
        this.frmError['en.lastname'] = this.getMessageFromError(error['en.lastname'])
        this.frmError.specialities = this.getMessageFromError(error.specialities)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    },
    async loadData () {
      let spct = await this.$http.get(this.$APP_CONFIG.api.specialties())
      if (spct) {
        this.specialities = spct.body
        this.specialty_filters = spct.body.map(r => {
          return { label: r.name, value: r.id }
        })
      }
    },
    async loadSubspecialty (specialtyId) {
      if (!specialtyId) {
        this.subspecialty_filters = []
        this.selected_subspecialty_filters = []
        this.selected_subspecialty_filter = null
        return
      }
      let sbspct = await this.$http.get(this.$APP_CONFIG.api.sub_specialities(specialtyId))
      if (sbspct) {
        this.subspecialty_filters = sbspct.body.map(r => {
          return { label: r.name, value: r.id }
        })
      }
    },
    async getDoctorsOptions (search) {
      this.doctorSearching = true
      let resp = await this.$http.get(this.$APP_CONFIG.api.admin.doctors(), {
        params: {
          doctor_name: search, clinic_id: this.clinic.id
        },
        credentials: true
      })

      this.doctorSearching = false
      if (resp) {
        this.doctor_filters = resp.body.data.map(r => {
          return {
            value: r.id,
            label: (this.$i18n.locale === 'th') ? r.name_th : r.name_en
          }
        })
      }
    }
  },
  watch: {
    q (v, old) {
      let debounchTime = 500
      clearTimeout(this._searchQ)
      this._searchQ = setTimeout(() => {
        this.refreshDoctorList()
        // this.$http.get(this.$APP_CONFIG.api.admin.doctors(), {
        //   params: { doctor_name: v, clinic_id: this.clinic.id }
        // }).then(res => {
        //   this.doctors = res.body.data || []

        //   Object.assign(this.paginator, {
        //     from: res.body.from,
        //     to: res.body.to,
        //     total: res.body.total,
        //     per_page: res.body.per_page,
        //     current_page: res.body.per_page,
        //     next_page_url: res.body.next_page_url,
        //     prev_page_url: res.body.prev_page_url
        //   })
        // })
      }, debounchTime) // delay
    },
    selected_specialities (newValue) {
      // update sub specialities
      var spid = +newValue.value
      this.$http.get(this.$APP_CONFIG.api.sub_specialities(spid)).then(res => {
        this.sub_specialities = res.body.map(function (s) {
          return { value: s.id, label: s.name }
        })
      })
    },
    selected_doctor_filters (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.selected_doctor_filters = [v[v.length - 1]]
        }
        this.selected_doctor_filter = data
      } else {
        this.selected_doctor_filter = null
      }
    },
    selected_specialty_filters (v, old) {
      var searchId = null
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.selected_specialty_filters = [v[v.length - 1]]
        }
        this.selected_specialty_filter = data
        searchId = data.value
      } else {
        this.selected_specialty_filter = null
      }

      this.loadSubspecialty(searchId)
    },
    selected_subspecialty_filters (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.selected_subspecialty_filters = [v[v.length - 1]]
        }
        this.selected_subspecialty_filter = data
      } else {
        this.selected_subspecialty_filter = null
      }
    },
    selected_doctor_filter (v, old) {
      this.refreshDoctorList()
    },
    selected_specialty_filter (v, old) {
      this.refreshDoctorList()
    },
    selected_subspecialty_filter (v, old) {
      this.refreshDoctorList()
    }
  },
  created () {
    // fetch spcialties
    this.loadData()

    this.refreshDoctorList()

    // Check it is in the step process or not
    this.isStepPrcess = typeof this.$route.params.step !== 'undefined'
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../../assets/base_container";
@import "../../../assets/base_pagination";
.flex {
  display: flex;
  align-items: center;

  & > div {
    margin-right: 1em;
  }

  .prefix-name {
    width: 150px;
  }

  .name {
    flex: 1;
  }
}

.doctor-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fafafa;
  border: 1px solid #ddd;
  margin-bottom: 0.5em;
  border-radius: 5px;
  
  h6 {
    margin: 0;
  }
  
  .doctor-content {
    flex: 2; 
    padding: 0.5rem;
    border-right: 1px solid #ddd;
  }

  .doctor-actions {
    padding: 1em;
    text-align: center;
  }
}

.remove-doctor-action {
  float: right;
}

.clinic-doctor-wrapper {

  .step-header {
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
        flex: 1;
    }
  }

}
</style>



// WEBPACK FOOTER //
// Doctors.vue?2eab530b